import React, { type JSX } from "react";
import { MagicCard } from "../@/components/magicui/magic-card";
import { useTranslation } from 'react-i18next';
import {
  FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt,
  FaShareAlt, FaProductHunt, FaImages, FaYoutube, FaStar
} from "react-icons/fa";

// Define expected service structure
type Service = {
  icon: string;
  title: string;
  description: string;
};

// Props to receive theme (light or dark)
interface WorkProps {
  theme: 'light' | 'dark';
}

const Work: React.FC<WorkProps> = ({ theme }) => {
  const { t } = useTranslation();
  const services = t('benefits.services', { returnObjects: true }) as Service[];

  return (
    <div id="benefits" className="p-10 text-center">
      <h1 className="text-3xl md:text-4xl text-amber-300 font-primary font-bold pb-10">
        {t('benefits.title')}
      </h1>
      <section className="container grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, index) => (
          <MagicCard
            key={index}
            className="cursor-pointer flex flex-col text-center items-center justify-center shadow-2xl p-4 whitespace-normal text-3xl overflow-hidden rounded-xl bg-white/10 dark:bg-black/10"
            gradientColor={theme === "dark" ? "#262626" : "#D9D9D955"}
            style={{ width: "200px", height: "100px" }}
          >
            <div className="flex items-center justify-center mb-2">
              {getServiceIcon(service.icon)}
            </div>
            <h2 className="text-xl truncate text-amber-300 font-secondary font-bold">
              {service.title}
            </h2>
            <h4 className="truncate text-wrap text-[16px] text-white">
              {service.description}
            </h4>
          </MagicCard>
        ))}
      </section>
    </div>
  );
};

// Helper to return icons dynamically
const getServiceIcon = (iconName: string) => {
  const iconProps = {
    className: "object-cover mb-2",
    size: "3rem",
    color: "#FFC107"
  };

  const icons: Record<string, JSX.Element> = {
    FaPhone: <FaPhone {...iconProps} />,
    FaWhatsapp: <FaWhatsapp {...iconProps} />,
    FaEnvelope: <FaEnvelope {...iconProps} />,
    FaMapMarkerAlt: <FaMapMarkerAlt {...iconProps} />,
    FaShareAlt: <FaShareAlt {...iconProps} />,
    FaProductHunt: <FaProductHunt {...iconProps} />,
    FaImages: <FaImages {...iconProps} />,
    FaYoutube: <FaYoutube {...iconProps} />,
    FaStar: <FaStar {...iconProps} />
  };

  return icons[iconName] || <FaStar {...iconProps} />;
};

export default Work;